import React, { Component } from 'react';
import { Card, message } from 'antd';
import { queryTalkList, querySaveTalk } from '@api/common/talk';
import Editor from './Editor';
import CommentItem from './CommentItem';
import './index.less';

export default class App extends Component {
  state = {
    comments: [],
    submitting: false,
  };

  componentDidMount() {
    this.itemUuid = this.props.target.uuid;
    this.getTalkList();
  }

  componentWillReceiveProps(nextProps) {
    if (this.itemUuid !== nextProps.target.uuid) {
      this.itemUuid = nextProps.target.uuid;
      this.getTalkList();
    }
  }

  getTalkList = () => {
    if (this.itemUuid) {
      queryTalkList({
        itemUuid: this.itemUuid,
      }).then(res => {
        if (res.statusCode === 200) {
          this.setState({
            comments: res.data,
          });
        }
      });
    }
  };

  postTalk = params => {
    if (!params.content) {
      message.warn('请输入评论内容');
      return;
    }
    if (!params.replyUuid) {
      this.setState({
        submitting: true,
      });
    }
    querySaveTalk(params).then(res => {
      if (res.statusCode === 200) {
        this.getTalkList();
        if (params.replyUuid) {
          const submits = {};
          submits[params.replyUuid] = false;
        } else {
          this.reply.talk = {};
          this.setState({
            submitting: false,
          });
        }
      }
    });
  };

  reply = {};

  handleSubmit = replyUuid => () => {
    this.reply[replyUuid] = this.reply[replyUuid] || {};
    this.postTalk({
      itemUuid: this.itemUuid,
      content: this.reply[replyUuid].content,
      atUuids: this.reply[replyUuid].atUuids,
      type: this.props.target.type,
    });
  };

  handleSubmitReply = record => () => {
    this.reply[record.uuid] = this.reply[record.uuid] || {};
    this.postTalk({
      itemUuid: this.itemUuid,
      content: this.reply[record.uuid].content,
      atUuids: this.reply[record.uuid].atUuids,
      type: this.props.target.type,
      replyUuid: record.uuid,
      toName: record.fromName,
      toUuid: record.fromUuid,
    });
  };

  handleChange = uuid => e => {
    this.reply[uuid] = this.reply[uuid] || {};
    this.reply[uuid].content = e.target.value;
  };

  handleMention = uuid => e => {
    this.reply[uuid] = this.reply[uuid] || {};
    this.reply[uuid].atUuids = e;
  };

  handleReply = uuid => {
    const { comments } = this.state;
    this.reply[uuid] = '';
    this.loopFindUuid(comments, uuid);
    this.setState({
      comments,
    });
  };

  loopFindUuid = (data, key) => {
    data.map(item => {
      if (item.uuid === key) {
        item.isReply = !item.isReply;
      } else if (item.children) {
        this.loopFindUuid(item.children, key);
      }
      return item;
    });
  };

  render() {
    const { comments, submitting } = this.state;
    const loopComments = data => {
      return data.map(item => {
        const parentProps = {
          ...item,
          onSubmit: this.handleSubmitReply(item),
          submitting,
          onChange: this.handleChange(item.uuid),
          onMention: this.handleMention(item.uuid),
          isReply: item.isReply,
          handleReply: this.handleReply,
        };
        return <CommentItem {...parentProps} key={item.uuid} />;
      });
    };
    return (
      <Card className="comment-list-box">
        <Editor
          onChange={this.handleChange('talk')}
          onMention={this.handleMention('talk')}
          onSubmit={this.handleSubmit('talk')}
          submitting={submitting}
          placeholder="输入评论"
        />
        {loopComments(comments)}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/comm/comment/Index.js